import { z } from 'zod'
import { expectedPaymentTypeSchema } from './expected-payment-response.schema'

export const importablePaymentResponseSchema = z.object({
  operationId: z.string(),
  type: expectedPaymentTypeSchema,
  ticker: z.string().nullable(),
  instrumentName: z.string().nullable(),
  paymentDate: z.string(),
  gross: z.number(),
  tax: z.number(),
  net: z.number(),
  currency: z.string(),
  // computed response flag: true when this historical payout matches an income the user
  // already recorded manually (display-only hint; the import action is unaffected by it)
  matched: z.boolean(),
})

export type ImportablePaymentResponseDto = z.infer<typeof importablePaymentResponseSchema>

export const importablePaymentsResponseSchema = z.object({
  payments: z.array(importablePaymentResponseSchema),
})

export type ImportablePaymentsResponseDto = z.infer<typeof importablePaymentsResponseSchema>
